import { usePlacesWidget } from "react-google-autocomplete";
import { withTranslation } from "react-i18next";
import SearchIcon from "@material-ui/icons/Search";
import i18n from "../../utils/LanguageSelector/i18n";

function AutoComplete({ ...props }) {
  const { ref } = usePlacesWidget({
    apiKey: process.env.REACT_APP_GOOGLE_API,
    onPlaceSelected: (place) => {
      props.onChange(place);
    },
    options: {
      types: ["establishment"],
      fields: ["address_components", "name"],
      /* componentRestrictions: { country: "hu" }, */
      offset: "3",
    },
  });
  return (
    <div className="AddressInputContainer" style={props.style}>
      <SearchIcon
        style={{
          position: "absolute",
          fontSize: "40px",
          color: "black",
          left: "1%",
        }}
      />
      <input
        ref={ref}
        className="AddressInput"
        style={{ paddingLeft: "40px" }}
        type="text"
        id={props.id}
        placeholder={i18n.t("general.lookforaddress")}
        defaultValue={props.defaultValue}
      />
    </div>
  );
}

export default withTranslation()(AutoComplete);
